// --- shared components ---
import { ModuleDashboard } from "../../components/module";
import { getTimekeepingModuleId } from "../../constants/timekeeping";

export function TimekeepingDashboard() {
  const domainId = localStorage.getItem("swm-current-workspace-id");
  const moduleId = getTimekeepingModuleId(domainId);
  return <ModuleDashboard moduleId={moduleId} />;
}

export default TimekeepingDashboard;
